import { useEffect } from 'react';

/**
 * Adds Esc to close and Enter to trigger primary CTA on modals.
 * Skips Enter when a <textarea> is focused or when onEnter is not provided.
 */
export function useModalKeyboard(
  isOpen: boolean,
  onClose: () => void,
  onEnter?: (() => void) | false | null
) {
  useEffect(() => {
    if (!isOpen) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        onClose();
        return;
      }

      if (e.key === 'Enter' && onEnter) {
        const tag = (e.target as HTMLElement)?.tagName;
        if (tag === 'TEXTAREA') return;
        e.preventDefault();
        onEnter();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose, onEnter]);
}
